import { useState } from "react";
import { Card, CardBody, Col, Input } from "reactstrap";
import { Btn, P } from "../../../../../AbstractElements";
import { ClipBoardOnTextInputTitle, Copy, Cut } from "../../../../../Constants/Constants";
import CommonCardHeader from "../../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const ClipboardOnTextInput = () => {
  const [inputValue, setInputValue] = useState("");

  const handleCopy = async () => {
    await navigator.clipboard.writeText(inputValue);
    setInputValue(inputValue);
  };
  const handleCut = async () => {
    await navigator.clipboard.writeText(inputValue);
    setInputValue("");
  };
  return (
    <Col sm="12" md="6">
      <Card>
        <CommonCardHeader title={ClipBoardOnTextInputTitle} />
        <CardBody>
          <div className="clipboaard-container">
            <P className="f-16">{"Cut/copy from text input"}</P>
            <Input type="text" placeholder="type some text to copy / cut" value={inputValue} onChange={(event) => setInputValue(event.target.value)} />
            <div className="mt-3 text-end">
              <Btn className="btn-clipboard me-2" color="primary" onClick={handleCopy}>
                <i className="fa fa-copy"></i> {Copy}
              </Btn>
              <Btn className="btn-clipboard-cut" color="secondary" onClick={handleCut}>
                <i className="fa fa-cut"></i> {Cut}
              </Btn>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default ClipboardOnTextInput;
